<template>
  <div>
    <div class='container'>
      <div class="up-input" >
        <div class='up-input-content' >
          <span class="phone-input-ico"></span>
          <input class="phone-input ploginInput"  maxlength="11" type='number' placeholder="请输入手机号"  bindinput="bindPhoneInput" v-model='inputPhone' />
        </div>
      </div>


      <div class="up-input" >
        <div class='up-input-content' style='width: 100%;'>
          <span class="key-input-ico"></span>
          <input class="key-input ploginInput" maxlength="6" type='number' placeholder="请输入验证码" bindinput="bindVerifyInput" v-model='inputVerify' />
              <div :class='[verifyButtonMsg === "发送验证码" ? "" : "verifydisabled","send-verify-text"]'   @click="sendVerifyCode">{{verifyButtonMsg}}</div>
        </div>
      </div>


    </div>
    <div class='reminder' v-if="isInputWrong">请输入正确的手机号和验证码</div>
    <!-- <div class="button-title {loginSrc.active ? 'enabled' : 'disabled'}" @click="phoneLogin" >登录</div> -->
    <div class="button-title enabled" @click="phoneLogin" >登录</div>

    <jloading :show="showLoading"></jloading>
    
  </div>
</template>
<script>
import jloading from '../../components/jloading'
const PHONE_NUMBER_LENGTH = 11;
const VERIFY_CODE_LENGTH = 4;
const VERIFY_BUTTON_INIT_MSG = "发送验证码"
const multipNum = 512;
const addNum = 9237045567;
const CODE_EXPAIRE = 60;
var interval
export default {
  name: '',
  components:{
    jloading
  },
  data () {
    return {
      inputPhone: "",
      inputVerify:"",
      verifyButtonMsg: VERIFY_BUTTON_INIT_MSG,
      isInputWrong:false,
      showLoading:false,
      jsCode:""
    }
  },
  created() {
    let query = this.$route.query || "";
    this.jsCode = query.code || "phoneCode"
    localStorage.setItem(this.$env+"jsCode",this.jsCode)
    this.$service.getStatisCommon("evn_open_page",{});
  },
  methods: {
    sendVerifyCode() {
      if (this.inputPhone.length !== PHONE_NUMBER_LENGTH || this.verifyButtonMsg !== VERIFY_BUTTON_INIT_MSG) {
        this.$toast("请输入正确的手机号")
        return;
      }

      this.doSendOtp()

      var closureFunc = this.showCurrentTime(CODE_EXPAIRE)
      let that = this;
      interval = setInterval(function(){
        closureFunc();
        if (parseInt(that.verifyButtonMsg, 0) <= 0) {
          clearInterval(interval)
          that.verifyButtonMsg = VERIFY_BUTTON_INIT_MSG;
        }
      },1000)
    },

    showCurrentTime: function (totalTime) {
      var funcb = () => {
        this.verifyButtonMsg = totalTime.toString() + "s";
        totalTime = totalTime - 1
      }
      return funcb
    },

    async doSendOtp(){
      var phoneNum = this.inputPhone
      var aesPhone = parseInt(phoneNum) * multipNum + addNum;
      let res = await this.$service.sendPhone(aesPhone)
    },
    async phoneLogin(){
      this.showLoading = true;
      let cellPhone = this.inputPhone;
      let code = this.inputVerify;
      let params = {
        "cellPhone": cellPhone,
        "code": code,
        "source": "7",
        "jsCode": this.jsCode,
        "ivForUserInfo": "test",
        "memberName": "test",
        "encryptedUserInfo": "test"

      }
      try{
        let res = await this.$service.goLogin(params)
        if(res.status === 200){
          this.$registLogin(res.result.memberId,res.result.token)
          this.$store.dispatch("user/login")
        }
        this.showLoading = false
        // this.$router.replace({ path: "/" });
        this.$router.go(-2);
      }catch(e){
        console.log(e)
        this.isInputWrong = true
        this.showLoading = false
      }
      this.$service.getStatisCommon("evn_click_button",{ed:params});
      this.$service.getStatisCommon("evn_close_page",{});
    }
    
  }
}
</script>
<style scoped lang='less'>
.container {
  display: flex;
  flex-direction: column;
  padding-top: 1.6rem;
  align-items: center;
}

.up-input {
  position: relative;
  margin-top:0.2667rem;
}

.input-image {
  width: 650rpx;
  height: 88rpx;
  align-self: center;
  margin-bottom: 32rpx;
}

.ic-phone-image {
  width: 28rpx;
  height: 40rpx;
  align-self: center;
}

.ic-key-image {
  width: 42rpx;
  height: 40rpx;
  align-self: center;
}

.phone-input {
  align-items: center;
  justify-content: center;
  color: rgb(85, 85, 85);
  font-size: 16px;
  position:relative;
}
.phone-input-ico{
    // content: " ";
    z-index:999;
    width: 0.64rem;
    height: 0.64rem;
    color: #C1C1C1;
    position: absolute;
    top:0.2933rem;
    left: 0.4267rem;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAJFBMVEVHcEzBwcHCwsLR0dHCwsLBwcHBwcHBwcHDw8PBwcHCwsLBwcFTV2xFAAAAC3RSTlMA9pEIgSam22K7STCF1SMAAAC4SURBVDjLY2AgG5iGgkEwmjCz+24oqDBAkQjfDQelyOKs0ts9Oqp3797Z0VS9MQBJwny3AwNDWFqaKgODye4CJInuLQi29g4kidnFCLbhNiQJ6QQEm207kmNBVsAA08ZRiVGJwSbBgFMCnKiDlJSA+YOBEylRM2QLg/LC7t2gHBCInA1WgziNgoIVIEW7kCQ4dyfDmGG7JyBnzuqNk5TAQFN6O0p+jkRk58moJcCyQkEwEM9ioDoAAPgIa1+tiK0NAAAAAElFTkSuQmCC");
    background-size: cover;
}

.key-input {
  /* align-items: center;
  justify-content: center; */
  color: rgb(85, 85, 85);
  font-size: 16px;
}

.key-input-ico{
    // content: " ";
    width: 0.64rem;
    height: 0.64rem;
    color: #C1C1C1;
    position: absolute;
    top: 0.2933rem;
    left: 0.4267rem;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAMFBMVEVHcEzCwsLDw8PBwcHBwcHCwsLCwsLDw8PCwsLCwsLBwcHCwsLCwsLCwsLCwsLBwcHgLPwdAAAAD3RSTlMAhTRy819SDMUem9nlRrIK5WFDAAABaklEQVQ4y2NgIAyYks0UsIkX7v///484pjjr+f9A8MUAQ0L+/w/R4Pf/f6GLM/7/N4GBgXP9/wVoEvf/gw1h/f8VTWL/Rwgd/6cARZztfwOEwfcf1Xq+/xegnoGpgAKWL3Azv6NIzP8HY63/hCKhD3e//F9cEt8GRGKaoXAkFgn2CFB8bC7AkMj5Dwau6BJf/v/fGHtN+v9/fzSJ//+bQPSN///RJVwhDHs0Cfkv0JTD648S65z+8KDL/4+cuLj+CyBSBXJMzf8Cj2n288gRYv8RyTokNsN7sCpOsOn6P5ATzwewENgFPF+QJPwPgNPUZxDJ8R8pZUFcApHg+z8BSQKXjvMfEBIodkBcBZGY/wPDHxAJZD9BfT7HCeTz/Z8wwoodJMuMElZIoauCErqI+GA6/wstf0BjMOV/O4oEez8kzvX+/56AmgerQKnkKjCVPEfPz9mQdHUUowBgt4akRCyFyTRBwUwiyiIAp5G1qof1KzwAAAAASUVORK5CYII=");
    background-size: cover;
}

.up-input-content{
    position: relative;
}

.button-verify-normal {
  position: absolute;
  margin-top: 0rpx;
  margin-right: 0rpx;
  width: 180rpx;
  height: 66rpx;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.reminder {
  position: absolute;
  font-family: PingFang-SC-Regular, 'Source Han Sans CN Regular', 'Noto Sans CJK SC Regular';
  color: rgb(235, 97, 15);
  font-size: 12px;
  margin: 0 1.8667rem;
  top: 4.8rem;
  left: -0.6933rem;
}

.login-image {
  margin-top: 24rpx;
  align-self: center;
  width: 650rpx;
  height: 88rpx;
}

.button-title {
    width: 8.8rem;
    height: 1.1733rem;
    border-radius: 1.1733rem;
    line-height: 1.1733rem;
    text-align: center;
    color: #fff;
    margin: 1.0667rem auto 0;
    font-size:16px;
}
.disabled{
    background: #D1D1D1;
}
.enabled{
    background: #FF7738;
}

.send-verify-text {
  text-align: center;
  width: 2.3467rem;
  height: 0.8rem;
  line-height: 0.8rem;
  position: absolute;
  color: #fff;
  font-size: 14px;
  top: 0.2133rem;
  /* transform: translateY(18rpx); */
  right: 0.24rem;
  background: #FF7738;
  border-radius: 0.4rem;
  /* transform: translate(-50%, -50%); */
  z-index: 10;
}
.verifydisabled{
    opacity: 0.4;
}
.verify-button-area {
  position: absolute;
  right: 140rpx;
  top: 30rpx;
  z-index: 10;
}

.ploginInput{
    width: 8.8rem;
    height: 1.1733rem;
    /* line-height: 88rpx; */
    border: 1px solid rgba(235,235,235,1);
    border-radius: 1.1733rem;
    padding-left: 1.3333rem;
}

.title{
    color: #C1C1C1;
    text-align: center;
    font-size: 28rpx;
    margin-top:220rpx;
    margin-bottom: 60rpx;
}
.title:before,.title:after{
    content: "";
    width: 100rpx;
    border-top: 1rpx #D1D1D1 solid; 
    display: inline-block;
    vertical-align: middle;
}
.title:before{
    margin-right: 10px;
}
.title:after{
    margin-left: 10px;
}

.wechartBtn{
    position: absolute;
    top:0;
    left:0;
    width:96rpx;
    height: 96rpx;
    background: none;
    padding: 0;
    border: none;
    z-index:10;
}
.wechartBtn:before,.wechartBtn:after{
    content: none;
}
.wechart{
    width: 96rpx;
    height: 96rpx;
    position: relative;
    margin: 0 auto;
}
.wechart image{
    width: 100%;
    height: 100%;
}
.wechartText{
    text-align: center;
    font-size:28rpx;
    color: #333333;
    margin-top:20rpx;
}


</style>